import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
export default function BaltimoreCounty() {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": "HomeAndConstructionBusiness",
      "@id": "https://triserveinc.com/#organization",
      "name": "TriServe",
      "telephone": "855-435-6631",
      "areaServed": "Baltimore County, MD"
    }, {
      "@type": "Service",
      "name": "Water Damage & Flood Restoration",
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "TriServe"
      },
      "areaServed": "Baltimore County, MD"
    }, {
      "@type": "Service",
      "name": "Sewage Backup Cleanup",
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "TriServe"
      },
      "areaServed": "Baltimore County, MD"
    }, {
      "@type": "Service",
      "name": "Fire & Smoke Damage Restoration",
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "TriServe"
      },
      "areaServed": "Baltimore County, MD"
    }, {
      "@type": "Service",
      "name": "Mold Remediation",
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "TriServe"
      },
      "areaServed": "Baltimore County, MD"
    }, {
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://triserveinc.com/"
      }, {
        "@type": "ListItem",
        "position": 2,
        "name": "Maryland",
        "item": "https://triserveinc.com/MarylandPage"
      }, {
        "@type": "ListItem",
        "position": 3,
        "name": "Baltimore County"
      }]
    }]
  };
  return <section id="baltimorecountyhero" data-nav="light" className="relative bg-background text-foreground border-b border-border overflow-hidden">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schemaData)
    }} />

      {/* Decorative background grid pattern */}
      <div className="pointer-events-none absolute inset-0 opacity-40 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" aria-hidden="true" />

      <div className="relative z-10 mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 pt-10 pb-16 sm:pt-14 sm:pb-24 lg:pt-16 lg:pb-28">
        {/* Breadcrumb Trail */}
        <Breadcrumb className="mb-6 sm:mb-8">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/MarylandPage">Maryland</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Baltimore County</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        {/* Content Block */}
        <div className="max-w-4xl space-y-6">
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-[1.12]">
            Baltimore County Disaster &amp; Emergency Restoration Services
          </h1>

          <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-2xl">
            24/7 rapid emergency response for water, fire, smoke, sewage, and mold
            restoration throughout Baltimore County, dispatched directly by local crews.
          </p>

          {/* Action CTAs */}
          <div className="pt-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-3.5 sm:gap-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm font-medium">
              <a href="tel:8554356631" className="inline-flex items-center justify-center gap-2">
                <Phone className="size-4" />
                <span>Call Now: 855-435-6631</span>
              </a>
            </Button>

            <Button asChild size="lg" variant="outline" className="border-border hover:bg-muted text-foreground font-medium">
              <Link to="/ContactRequestServicePage" className="inline-flex items-center justify-center gap-2">
                <span>Request Service</span>
                <ArrowRight className="size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}